import { render, staticRenderFns } from "./dr-layout-main-component.vue?vue&type=template&id=f24b3df4&"
import script from "./dr-layout-main-component.vue?vue&type=script&lang=js&"
export * from "./dr-layout-main-component.vue?vue&type=script&lang=js&"
import style0 from "./dr-layout-main-component.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports